import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { RequireAuth } from '@/auth/require-auth';
import { WorkspaceHeader } from '@/integrations/workspace-header';
import { AboutPage } from '@/pages/about';
import { RecipesPage } from '@/pages/recipes';
import { PrivacyPage } from '@/pages/privacy';
import { SettingsPage } from '@/pages/settings';
import { IntegrationsHubPage } from '@/integrations/integrations-hub-page';
import { WhoopWorkspacePage } from '@/integrations/whoop-workspace-page';
import '@/integrations/whoop.css';

/**
 * Global chrome: every page renders inside the dark shell under the workspace
 * header, so the top nav is always present regardless of route.
 */
function RootLayout() {
  return (
    <div
      className="ww-root"
      style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}
    >
      <WorkspaceHeader />
      <Outlet />
    </div>
  );
}

export function App() {
  return (
    <Routes>
      <Route element={<RootLayout />}>
        {/* The root is never a page of its own — About is the landing page. */}
        <Route path="/" element={<Navigate to="/about" replace />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/recipes" element={<RecipesPage />} />
        {/* Public: WHOOP (and other integration) app registrations require a
            reachable privacy policy URL. */}
        <Route path="/privacy" element={<PrivacyPage />} />
        {/* Settings holds the real account actions (connect/disconnect), so it
            sits behind sign-in. The integrations pages below stay public on
            purpose: they showcase the site owner's data to visitors, and every
            /api/whoop route requires a session. */}
        <Route element={<RequireAuth />}>
          <Route path="/settings" element={<SettingsPage />} />
        </Route>
        <Route path="/integrations" element={<IntegrationsHubPage />} />
        <Route
          path="/integrations/whoop"
          element={<Navigate to="/integrations/whoop/now" replace />}
        />
        <Route path="/integrations/whoop/:page" element={<WhoopWorkspacePage />} />
      </Route>
    </Routes>
  );
}
